import { render, staticRenderFns } from "./PageWeight.vue?vue&type=template&id=24de687e"
import script from "./PageWeight.vue?vue&type=script&lang=js"
export * from "./PageWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports